<app-masterpage>
</app-masterpage>
<div class="page-wrapper">
    <app-header>
    </app-header>
    <div class="container-fluid pt-custom pb-5">
        <!-- onclick="outerbody();" -->
        <div class="row">
            <div class="col-10">
                <h4 class="fs-title">Registration Details</h4>
            </div>
        </div>
        <div class="row card">
            <div class="col-lg-12">
                <div class="row" *ngIf="visiblePendingDiv" style="display: none;">
                    <div class="col-lg-12 col-md-12 col-12">
                        <button class="btn btn-success" type="button" (click)="viewPedingReq()"
                            style="margin: 5px;float: right;">View Pending Request Data</button>
                    </div>
                </div>
                <div class="row justify-content-center">
                    <div class="col-lg-12 col-md-12 col-12 p-4">
                        <form #RegistrationForm="ngForm" id="RegistrationForm" class="msform"
                            (ngSubmit)="onSubmit(data)">
                            <div class="row mt-2">
                                <div class="form-group col-lg-4 col-md-12 col-12">
                                    <label><b>College code</b><span class="text-danger">*</span></label>
                                    <input type="text" class="form-control" #UDiseNo="ngModel" ngModel name="UDiseNo"
                                        [(ngModel)]="data.UDiseNo" disabled placeholder="Enter college code"
                                        maxlength="50" required>
                                    <span *ngIf="RegistrationForm.submitted && UDiseNo.invalid">
                                        <p *ngIf="UDiseNo.errors.required" class="error_message" style="color: red;">
                                            College code is required
                                        </p>
                                    </span>
                                </div>
                                <!-- <div class="form-group col-lg-4 col-md-12 col-12">
                                    <label><b>S.S.C. INDEX NO.</b></label>
                                    <input type="text" class="form-control" #SSCIndexNo="ngModel" ngModel
                                        name="SSCIndexNo" [(ngModel)]="data.SSCIndexNo" maxlength="50" disabled
                                        style="text-transform: uppercase;" placeholder="ENTER S.S.C. INDEX NO.">
                                </div>
                                <div class="form-group col-lg-4 col-md-12 col-12">
                                    <label><b>H.S.C. INDEX NO.</b></label>
                                    <input type="text" class="form-control" #HSCIndexNO="ngModel" ngModel
                                        name="HSCIndexNO" [(ngModel)]="data.HSCIndexNO" maxlength="50" disabled
                                        style="text-transform: uppercase;" placeholder="ENTER H.S.C. INDEX NO.">
                                </div> -->
                                <!-- </div>
                            <div class="row mt-2">
                                <div class="form-group col-lg-4 col-md-12 col-12">
                                    <label><b>Office</b><span class="text-danger">*</span></label>
                                    <select class="form-control" #Office="ngModel" ngModel name="Office" disabled
                                        [(ngModel)]="data.Office" required>
                                        <option *ngFor="let office of offices" [value]="office.value"
                                            [selected]="data.Office == office.value">
                                            {{ office.text }}
                                        </option>
                                    </select>
                                    <span *ngIf="RegistrationForm.submitted ">
                                        <p *ngIf="data.Office == 0" class="error_message" style="color: red;">
                                            Office is required
                                        </p>
                                    </span>
                                </div> -->
                                <div class="form-group col-lg-4 col-md-12 col-12">
                                    <label><b>Type of trust</b><span class="text-danger">*</span></label>
                                    <select class="form-control" #TypeOfTrust="ngModel" ngModel name="TypeOfTrust"
                                        disabled [(ngModel)]="data.TypeOfTrust" required>
                                        <option *ngFor="let typeoftrust of typeOfTrusts" [value]="typeoftrust.value"
                                            [selected]="data.TypeOfTrust == typeoftrust.value">
                                            {{ typeoftrust.text }}
                                        </option>
                                    </select>
                                    <span *ngIf="RegistrationForm.submitted">
                                        <p *ngIf="data.TypeOfTrust == 0" class="error_message" style="color: red;">
                                            Type of trust is required
                                        </p>
                                    </span>
                                </div>
                                <!-- <div class="form-group col-lg-4 col-md-12 col-12" *ngIf="visibleAquireDate">
                                    <label><b>Index no. acquire date</b><span class="text-danger">*</span></label>
                                    <input type="date" placeholder="Select Date" id="AcquiredDate" class="form-control"
                                        #AcquiredDate="ngModel" ngModel name="AcquiredDate" disabled
                                        [(ngModel)]="data.AcquiredDate" required>
                                    <span
                                        *ngIf="RegistrationForm.submitted && AcquiredDate.invalid && visibleAquireDate">
                                        <p *ngIf="AcquiredDate.errors.required" class="error_message"
                                            style="color: red;">
                                            Index no. acquire date is required
                                        </p>
                                    </span>
                                </div> -->
                            </div>
                            <div class="row mt-2">
                                <div class="form-group col-lg-4 col-md-12 col-12">
                                    <label><b>Area</b><span class="text-danger">*</span></label>
                                    <textarea class="form-control" #Area="ngModel" ngModel name="Area" rows="3"
                                        maxlength="300" style="height: 60px" disabled [(ngModel)]="data.Area"
                                        required></textarea>
                                    <span *ngIf="RegistrationForm.submitted && Area.invalid">
                                        <p *ngIf="Area.errors.required" class="error_message" style="color: red;">
                                            Area is required
                                        </p>
                                    </span>
                                </div>
                                <div class="form-group col-lg-4 col-md-12 col-12">
                                    <label><b>State</b><span class="text-danger">*</span></label>
                                    <select class="form-control" #State="ngModel" ngModel name="State" disabled
                                        (change)="fillCity()" [(ngModel)]="data.State" required>
                                        <option *ngFor="let state of states" [value]="state.value"
                                            [selected]="data.State == state.value">
                                            {{ state.text }}
                                        </option>
                                    </select>
                                    <span *ngIf="RegistrationForm.submitted ">
                                        <p *ngIf="data.State == 0" class="error_message" style="color: red;">
                                            State is required
                                        </p>
                                    </span>
                                </div>
                                <div class="form-group col-lg-4 col-md-12 col-12">
                                    <label><b>City</b><span class="text-danger">*</span></label>
                                    <select class="form-control" #City="ngModel" ngModel name="City" disabled
                                        [(ngModel)]="data.City" required>
                                        <option *ngFor="let city of cities" [value]="city.value"
                                            [selected]="data.City == city.value">
                                            {{ city.text }}
                                        </option>
                                    </select>
                                    <span *ngIf="RegistrationForm.submitted ">
                                        <p *ngIf="data.City == 0 || data.City == undefined" class="error_message"
                                            style="color: red;">
                                            City is required
                                        </p>
                                    </span>
                                </div>
                            </div>
                            <div class="row mt-2">
                                <div class="form-group col-lg-4 col-md-12 col-12">
                                    <label><b>Trust name</b><span class="text-danger">*</span></label>
                                    <input type="text" class="form-control" #Trust="ngModel" ngModel name="Trust"
                                        disabled [(ngModel)]="data.Trust" maxlength="200" placeholder="Enter trust name"
                                        required>
                                    <span *ngIf="RegistrationForm.submitted && Trust.invalid">
                                        <p *ngIf="Trust.errors.required" class="error_message" style="color: red;">
                                            Trust name is required
                                        </p>
                                    </span>
                                </div>
                                <div class="form-group col-lg-4 col-md-12 col-12">
                                    <label><b>Trust address</b><span class="text-danger">*</span></label>
                                    <input type="text" class="form-control" #TrustAddress="ngModel" ngModel disabled
                                        name="TrustAddress" [(ngModel)]="data.TrustAddress" maxlength="300"
                                        placeholder="Enter trust address" (keypress)="blockSpecialChar($event)"
                                        required>
                                    <span *ngIf="RegistrationForm.submitted && TrustAddress.invalid">
                                        <p *ngIf="TrustAddress.errors.required" class="error_message"
                                            style="color: red;">
                                            Trust address is required
                                        </p>
                                    </span>
                                </div>
                                <div class="form-group col-lg-4 col-md-12 col-12">
                                    <label><b>Contact / Mobile no.</b><span class="text-danger">*</span></label>
                                    <input type="text" class="form-control" #TrustMobileNo="ngModel" ngModel
                                        name="TrustMobileNo" [(ngModel)]="data.TrustMobileNo" numbersOnly minlength="10"
                                        maxlength="10" disabled placeholder="Enter contact / mobile no." required>
                                    <span *ngIf="RegistrationForm.submitted && TrustMobileNo.invalid">
                                        <p *ngIf="TrustMobileNo.errors.required" class="error_message"
                                            style="color: red;">
                                            Contact / Mobile no. is required
                                        </p>
                                        <p *ngIf="TrustMobileNo.errors.minlength" class="error_message"
                                            style="color: red;">
                                            Contact / Mobile no. must be of 10 digit
                                        </p>
                                        <p *ngIf="TrustMobileNo.errors.maxlength" class="error_message"
                                            style="color: red;">
                                            Contact / Mobile no. must be of maximun 10 digit
                                        </p>
                                    </span>
                                </div>
                                <div class="form-group col-lg-4 col-md-12 col-12">
                                    <label><b>Trust mail id</b><span class="text-danger">*</span></label>
                                    <input type="text" class="form-control" #TrustMailID="ngModel" ngModel
                                        name="TrustMailID" [(ngModel)]="data.TrustMailID" maxlength="50" disabled
                                        pattern="^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+$" placeholder="ENTER TRUST MAIL ID"
                                        required>
                                    <span *ngIf="RegistrationForm.submitted && TrustMailID.invalid">
                                        <p *ngIf="TrustMailID.errors.required" class="error_message"
                                            style="color: red;">
                                            Trust mail id is required
                                        </p>
                                        <p *ngIf="TrustMailID.errors.pattern" class="error_message" style="color: red;">
                                            Trust mail id is invalid
                                        </p>
                                    </span>
                                </div>
                            </div>
                            <div class="row mt-2">
                                <div class="form-group col-lg-4 col-md-12 col-12">
                                    <label><b>College name</b><span class="text-danger">*</span></label>
                                    <input type="text" class="form-control" #SchoolName="ngModel" ngModel disabled
                                        name="SchoolName" [(ngModel)]="data.SchoolName" maxlength="200"
                                        placeholder="Enter college name" required>
                                    <span *ngIf="RegistrationForm.submitted && SchoolName.invalid">
                                        <p *ngIf="SchoolName.errors.required" class="error_message" style="color: red;">
                                            College name is required
                                        </p>
                                    </span>
                                </div>
                                <div class="form-group col-lg-4 col-md-12 col-12">
                                    <label><b>College address</b><span class="text-danger">*</span></label>
                                    <input type="text" class="form-control" #SchoolAddress="ngModel" ngModel disabled
                                        name="SchoolAddress" [(ngModel)]="data.SchoolAddress" maxlength="300"
                                        placeholder="Enter college address" (keypress)="blockSpecialChar($event)"
                                        required>
                                    <span *ngIf="RegistrationForm.submitted && SchoolAddress.invalid">
                                        <p *ngIf="SchoolAddress.errors.required" class="error_message"
                                            style="color: red;">
                                            College address is required
                                        </p>
                                    </span>
                                </div>
                                <div class="form-group col-lg-4 col-md-12 col-12">
                                    <label><b>College pincode</b><span class="text-danger">*</span></label>
                                    <input type="text" class="form-control" #pincode="ngModel" ngModel disabled
                                        name="pincode" [(ngModel)]="data.Pincode" maxlength="6"
                                        placeholder="Enter college pincode" (keypress)="blockSpecialChar($event)"
                                        required>
                                    <span *ngIf="RegistrationForm.submitted && pincode.invalid">
                                        <p *ngIf="pincode.errors.required" class="error_message" style="color: red;">
                                            College pincode is required
                                        </p>
                                    </span>
                                </div>
                                <div class="form-group col-lg-4 col-md-12 col-12">
                                    <label><b>Contact / Mobile no.</b><span class="text-danger">*</span></label>
                                    <input type="text" class="form-control" #SchoolMobileno="ngModel" ngModel disabled
                                        name="SchoolMobileno" [(ngModel)]="data.SchoolMobileno" minlength="10"
                                        numbersOnly maxlength="10" placeholder="Enter contact / mobile no." required>
                                    <span *ngIf="RegistrationForm.submitted && SchoolMobileno.invalid">
                                        <p *ngIf="SchoolMobileno.errors.required" class="error_message"
                                            style="color: red;">
                                            Contact / mobile no. is required
                                        </p>
                                        <p *ngIf="SchoolMobileno.errors.minlength" class="error_message"
                                            style="color: red;">
                                            Contact / mobile no. must be of 10 digit
                                        </p>
                                        <p *ngIf="SchoolMobileno.errors.maxlength" class="error_message"
                                            style="color: red;">
                                            Contact / mobile no. must be of maximun 10 digit
                                        </p>
                                    </span>
                                </div>
                                <div class="form-group col-lg-4 col-md-12 col-12">
                                    <label><b>College mail id</b><span class="text-danger">*</span></label>
                                    <input type="text" class="form-control" #SchoolMailID="ngModel" ngModel
                                        name="SchoolMailID" [(ngModel)]="data.SchoolMailID" maxlength="50" disabled
                                        pattern="^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+$" placeholder="Enter college mail id"
                                        required>
                                    <span *ngIf="RegistrationForm.submitted && SchoolMailID.invalid">
                                        <p *ngIf="SchoolMailID.errors.required" class="error_message"
                                            style="color: red;">
                                            College mail id is required
                                        </p>
                                        <p *ngIf="SchoolMailID.errors.pattern" class="error_message"
                                            style="color: red;">
                                            College mail id is invalid
                                        </p>
                                    </span>
                                </div>
                            </div>
                            <div class="row mt-2">
                                <div class="form-group col-lg-4 col-md-12 col-12">
                                    <label><b>College location</b><span class="text-danger">*</span></label>
                                    <select class="form-control" #SchoolLocation="ngModel" ngModel name="SchoolLocation"
                                        disabled [(ngModel)]="data.SchoolLocation" required>
                                        <option *ngFor="let location of locations" [value]="location.value"
                                            [selected]="data.SchoolLocation == location.value">
                                            {{ location.text }}
                                        </option>
                                    </select>
                                    <span *ngIf="RegistrationForm.submitted ">
                                        <p *ngIf="data.SchoolLocation == 0 || data.SchoolLocation == undefined"
                                            class="error_message" style="color: red;">
                                            College location is required
                                        </p>
                                    </span>
                                </div>
                                <div class="form-group col-lg-4 col-md-12 col-12">
                                    <label><b>College type</b><span class="text-danger">*</span></label>
                                    <select class="form-control" #SchoolType="ngModel" ngModel name="SchoolType"
                                        disabled [(ngModel)]="data.SchoolType" required>
                                        <option *ngFor="let type of types" [value]="type.value"
                                            [selected]="data.SchoolType == type.value">
                                            {{ type.text }}
                                        </option>
                                    </select>
                                    <span *ngIf="RegistrationForm.submitted ">
                                        <p *ngIf="data.SchoolType == 0 || data.SchoolType == undefined"
                                            class="error_message" style="color: red;">
                                            College type is required
                                        </p>
                                    </span>
                                </div>
                                <div class="form-group col-lg-4 col-md-12 col-12">
                                    <label><b>Registration date</b><span class="text-danger">*</span></label>
                                    <input type="date" placeholder="Select Date" id="RegistrationDate" disabled
                                        class="form-control" #RegistrationDate="ngModel" ngModel name="RegistrationDate"
                                        [(ngModel)]="data.RegistrationDate" required>
                                    <span *ngIf="RegistrationForm.submitted && RegistrationDate.invalid">
                                        <p *ngIf="RegistrationDate.errors.required" class="error_message"
                                            style="color: red;">
                                            Registration date is required
                                        </p>
                                    </span>
                                </div>
                            </div>
                            <div class="row mt-2">
                                <div class="form-group col-lg-4 col-md-12 col-12">
                                    <label><b>Year</b></label>
                                    <select class="form-control" #YearID="ngModel" ngModel name="YearID"
                                        [(ngModel)]="data.YearID" (change)="fillRegistrationDetail()" disabled required>
                                        <option *ngFor="let year of yearlist" [value]="year.value"
                                            [selected]="data.YearID == year.value">
                                            {{ year.text }}
                                        </option>
                                    </select>
                                    <span *ngIf="RegistrationForm.submitted && YearID.invalid">
                                        <p *ngIf="data.YearID == 0 || data.YearID == undefined" class="error_message"
                                            style="color: red;">
                                            Year is required
                                        </p>
                                    </span>
                                </div>
                            </div>
                            <div class="row mt-2">
                                <div class="form-group col-lg-2 col-md-12 col-12">
                                    <label><b>University</b><span class="text-danger">*</span></label> <br>
                                    <label *ngFor="let b of boards; let i=index">
                                        <input type="checkbox" id="chkBoard{{i}}" name="chkBoard{{i}}" />
                                        &nbsp;&nbsp; {{b.text}} &nbsp;&nbsp;
                                    </label>
                                    <span *ngIf="RegistrationForm.submitted ">
                                        <p *ngIf="data.Board == '' " class="error_message" style="color: red;">
                                            University is required
                                        </p>
                                    </span>
                                </div>
                                <div class="form-group col-lg-3 col-md-12 col-12">
                                    <label><b>Medium</b><span class="text-danger">*</span></label><br>
                                    <label *ngFor="let m of mediums; let i=index">
                                        <input type="checkbox" id="chkmedium{{i}}" name="chkmedium{{i}}"
                                            (change)="fillCourse()" />
                                        &nbsp;&nbsp; {{m.text}} &nbsp;&nbsp;
                                    </label>
                                    <span *ngIf="RegistrationForm.submitted ">
                                        <p *ngIf="data.Medium == ''" class="error_message" style="color: red;">
                                            Medium is required
                                        </p>
                                    </span>
                                </div>
                                <div class="form-group col-lg-3 col-md-12 col-12">
                                    <label><b>Institute</b><span class="text-danger">*</span></label><br>
                                    <label *ngFor="let ins of institutetypes; let i=index">
                                        <input type="checkbox" id="chkinstitute{{i}}" name="chkinstitute{{i}}" [value]="ins.value"
                                        (change)="fillCourse()" />
                                        &nbsp;&nbsp; {{ins.text}} &nbsp;&nbsp;
                                    </label>
                                    <span *ngIf="RegistrationForm.submitted ">
                                        <p *ngIf="data.InstituteTypeID == ''" class="error_message" style="color: red;">
                                            Institute Type is required
                                        </p>
                                    </span>
                                </div>
                                <div class="form-group col-lg-4 col-md-12 col-12">
                                    <label><b>Faculty</b><span class="text-danger">*</span></label> <br />
                                    <label *ngFor="let s of sections; let i=index">
                                        <input type="checkbox" id="chksection{{i}}" name="chksection{{i}}"
                                            (change)="fillCourse()" />
                                        &nbsp;&nbsp; {{s.text}} &nbsp;&nbsp;
                                    </label>
                                    <span *ngIf="RegistrationForm.submitted ">
                                        <p *ngIf="data.Section == ''" class="error_message" style="color: red;">
                                            Faculty is required
                                        </p>
                                    </span>
                                </div>
                            </div>
                            <div class="row mt-2" *ngIf="standards != undefined && standards.length > 0">
                                <div class="form-group col-lg-10 col-md-12 col-12">
                                    <label><b>Course</b><span class="text-danger">*</span></label> <br />
                                    <label *ngFor="let s of standards; let i=index">
                                        <input type="checkbox" id="chkStd{{i}}" name="chkStd{{i}}"
                                            (change)="manageRegDoc(i,s.text,s.MediumID,s.sectionID,s.value);"  />
                                        &nbsp;&nbsp; {{s.text}} &nbsp;&nbsp;
                                    </label>
                                </div>
                            </div>
                            <div class="border border-dark  bg-custom  p-2">
                                <div class="row mt-2 " style="margin: 2px;">
                                    <input type="hidden" value="-1" id="hid_trusteeDetailID">
                                    <div class="form-group col-lg-3 col-md-12 col-12 mb-0">
                                        <label><b>Trustee's name</b><span class="text-danger">*</span></label>
                                        <input type="text" class="form-control" #TrusteeName="ngModel" ngModel
                                            name="TrusteeName" [(ngModel)]="data.TrusteeName" maxlength="200"
                                            placeholder="Enter trustee's name">
                                        <!-- <span *ngIf="RegistrationForm.submitted && TrusteeName.invalid">
                                                <p *ngIf="TrusteeName.errors.required" class="error_message"
                                                    style="color: red;">
                                                    Trustee's Name is required
                                                </p>
                                            </span> -->
                                    </div>
                                    <div class="form-group col-lg-3 col-md-12 col-12 mb-0">
                                        <label><b>Trustee Address</b><span class="text-danger">*</span></label>
                                        <input type="text" class="form-control" #TrusteeAddress="ngModel" ngModel
                                            name="TrusteeAddress" [(ngModel)]="data.TrusteeAddress" maxlength="300"
                                            (keypress)="blockSpecialChar($event)" placeholder="Enter trustee address">
                                        <!-- <span *ngIf="RegistrationForm.submitted && TrusteeAddress.invalid">
                                                <p *ngIf="TrusteeAddress.errors.required" class="error_message"
                                                    style="color: red;">
                                                    Trustee Address is required
                                                </p>
                                            </span> -->
                                    </div>
                                    <div class="form-group col-lg-3 col-md-12 col-12 mb-0">
                                        <label><b>Contact / Mobile no.</b><span class="text-danger">*</span></label>
                                        <input type="text" class="form-control" #TrusteeMobileNo="ngModel" ngModel
                                            name="TrusteeMobileNo" [(ngModel)]="data.TrusteeMobileNo" minlength="10"
                                            maxlength="10" placeholder="Enter Contact / Mobile no." numbersOnly>
                                        <!-- <span *ngIf="RegistrationForm.submitted && TrusteeMobileNo.invalid">
                                                <p *ngIf="TrusteeMobileNo.errors.required" class="error_message"
                                                    style="color: red;">
                                                    Contact / Mobile No. is required
                                                </p>
                                                <p *ngIf="TrusteeMobileNo.errors.minlength" class="error_message"
                                                    style="color: red;">
                                                    Contact / Mobile No. must be of 10 digit
                                                </p>
                                                <p *ngIf="TrusteeMobileNo.errors.maxlength" class="error_message"
                                                    style="color: red;">
                                                    Contact / Mobile No. must be of maximun 10 digit
                                                </p>
                                            </span> -->
                                    </div>
                                    <div class="form-group col-lg-3 col-md-12 col-12 mb-0">
                                        <label><b>Trustee's mail id</b><span class="text-danger">*</span></label>
                                        <input type="text" class="form-control" #TrusteeMailID="ngModel" ngModel
                                            name="TrusteeMailID" [(ngModel)]="data.TrusteeMailID" maxlength="50"
                                            placeholder="Enter trustee's mail id"
                                            pattern="^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+$">
                                        <!-- <span *ngIf="RegistrationForm.submitted && TrusteeMailID.invalid">
                                                <p *ngIf="TrusteeMailID.errors.required" class="error_message"
                                                    style="color: red;">
                                                    Trustee's Mail ID is required
                                                </p>
                                                <p *ngIf="TrusteeMailID.errors.pattern" class="error_message"
                                                    style="color: red;">
                                                    Trustee's Mail ID is invalid
                                                </p>
                                            </span> -->
                                    </div>
                                </div>
                                <div class="row  mt-2">
                                    <div class="col-xl-1 col-md-2 col-3">
                                        <button class="btn btn-success ml-3" type="button" style="margin: 5px;"
                                            (click)="addTrustee()">Add</button>
                                    </div>
                                    <div class="col-xl-1 col-md-2 col-3">
                                        <button class="btn btn-primary" type="button" style="margin: 5px;"
                                            (click)="clearTrustee()">Clear</button>
                                    </div>
                                </div>
                                <div class="form-group col-lg-12 col-md-12 col-12 mt-4">
                                    <div class="table-responsive">
                                        <table class="table table-bordered" *ngIf="TrusteeDetail.length > 0">
                                            <thead>
                                                <tr>
                                                    <th>Trustee's name</th>
                                                    <th>Trustee's address</th>
                                                    <th>Trustee's Contact / Mobile no.</th>
                                                    <th>Trustee's mail id</th>
                                                    <th>ACTION</th>
                                                </tr>
                                            </thead>
                                            <tr *ngFor="let t of TrusteeDetail;let i = index">
                                                <td>{{t.TrusteeName}}</td>
                                                <td>{{t.TrusteeAddress}}</td>
                                                <td>{{t.TrusteeMobileNo}}</td>
                                                <td>{{t.TrusteeMailID}}</td>
                                                <td style="white-space: nowrap;">
                                                    <button type="button" class="btn btn-success mt-0 mb-0 d-inline"
                                                        (click)="editTrustee(i)">Edit</button>
                                                    &nbsp; <button type="button" class="btn btn-danger mt-0 d-inline"
                                                        (click)="deleteTrustee(i)">Delete</button>
                                                </td>
                                            </tr>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <!-- // Infrastructure and Owner entry remove from page.
                            <div class="border border-dark  bg-custom  p-2 mt-2">
                                <h4>Infrastructure Details</h4>
                                <hr style="margin: 0;">
                                <div class="row mt-2 " style="margin: 2px;">
                                    <input type="hidden" value="-1" id="hid_InfrastructureDetailID">
                                    <div class="form-group col-lg-3 col-md-12 col-12">
                                        <label><b>Infrastructure Type</b><span class="text-danger">*</span></label>
                                        <select class="form-control" #InfrastructureID="ngModel" ngModel
                                            name="InfrastructureID" [(ngModel)]="data.InfrastructureID" required>
                                            <option *ngFor="let inf of infrastructures" [value]="inf.value"
                                                [selected]="data.InfrastructureID == inf.value">
                                                {{ inf.text }}
                                            </option>
                                        </select>
                                    </div>
                                    <div class="form-group col-lg-3 col-md-12 col-12 mb-0">
                                        <label><b>No. of infrastructure</b><span class="text-danger">*</span></label>
                                        <input type="text" class="form-control" #NoOfInfrastructure="ngModel" ngModel
                                            name="NoOfInfrastructure" [(ngModel)]="data.NoOfInfrastructure"
                                            maxlength="10" placeholder="Enter no. of infrastructure" numbersOnly>
                                    </div>
                                    <div class="form-group col-lg-3 col-md-12 col-12 mb-0">
                                        <label><b>Infrastructure size (in Sq.Ft.)</b><span
                                                class="text-danger">*</span></label>
                                        <input type="text" class="form-control"
                                            #InfrastructureSize="ngModel" ngModel
                                            name="InfrastructureSize"
                                            [(ngModel)]="data.InfrastructureSize" maxlength="10"
                                            placeholder="Enter infrastructure size" numbersOnly>
                                    </div>
                                </div>
                                <div class="row  mt-2">
                                    <div class="col-xl-1 col-md-2 col-3">
                                        <button class="btn btn-success ml-3" type="button" style="margin: 5px;"
                                            (click)="addInfrastructure()">Add</button>
                                    </div>
                                    <div class="col-xl-1 col-md-2 col-3">
                                        <button class="btn btn-primary" type="button" style="margin: 5px;"
                                            (click)="clearInfrastructure()">Clear</button>
                                    </div>
                                </div>
                                <div class="form-group col-lg-12 col-md-12 col-12 mt-4"
                                    *ngIf="InfrastructureDetail != undefined && InfrastructureDetail.length > 0">
                                    <div class="table-responsive">
                                        <table class="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th>Infrastructure type</th>
                                                    <th>No. of infrastructure</th>
                                                    <th>Infrastructure size</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tr *ngFor="let t of InfrastructureDetail;let i = index">
                                                <td>{{t.InfrastructureType}}</td>
                                                <td>{{t.NoOfInfrastructure}}</td>
                                                <td>{{t.InfrastructureSize}}</td>
                                                <td style="white-space: nowrap;">
                                                    <button type="button" class="btn btn-success mt-0 mb-0 d-inline"
                                                        (click)="editInfrastructure(i)">Edit</button>
                                                    &nbsp; <button type="button" class="btn btn-danger mt-0 d-inline"
                                                        (click)="deleteInfrastructure(i)">Delete</button>
                                                </td>
                                            </tr>
                                        </table>
                                    </div>
                                </div>
                            </div> -->
                            <div class="border border-dark  bg-custom  p-2 mt-2">
                                <h4>Employee Details</h4>
                                <hr style="margin: 0;">
                                <div class="row mt-2 " style="margin: 2px;">
                                    <input type="hidden" value="-1" id="hid_EmployeeDetailID">
                                    <div class="form-group col-lg-4 col-md-12 col-12">
                                        <label><b>Employee category</b><span class="text-danger">*</span></label>
                                        <select class="form-control" #EmployeeTypeID="ngModel" ngModel
                                            name="EmployeeTypeID" [(ngModel)]="data.EmployeeTypeID" required>
                                            <option *ngFor="let inf of employeetypes" [value]="inf.value"
                                                [selected]="data.EmployeeTypeID == inf.value">
                                                {{ inf.text }}
                                            </option>
                                        </select>
                                    </div>
                                    <div class="form-group col-lg-4 col-md-12 col-12 mb-0">
                                        <label><b>No. of permanent employee</b></label>
                                        <input type="text" class="form-control" #NoOfPermanentEmployee="ngModel" ngModel
                                            name="NoOfPermanentEmployee" [(ngModel)]="data.NoOfPermanentEmployee"
                                            maxlength="10" placeholder="Enter no. of permanent employee" numbersOnly>
                                    </div>
                                    <div class="form-group col-lg-4 col-md-12 col-12 mb-0">
                                        <label><b>No. of Ad-Hoc employee</b></label>
                                        <input type="text" class="form-control" #NoOfAdhocEmployee="ngModel" ngModel
                                            name="NoOfAdhocEmployee" [(ngModel)]="data.NoOfAdhocEmployee" maxlength="10"
                                            placeholder="Enter no. of Ad-Hoc employee" numbersOnly>
                                    </div>
                                </div>
                                <div class="row mt-2 " style="margin: 2px;">
                                    <div class="form-group col-lg-4 col-md-12 col-12 mb-0">
                                        <label><b>Total permanent employee's salary</b></label>
                                        <input type="text" class="form-control" #TotalPermanentSalary="ngModel" ngModel
                                            name="TotalPermanentSalary" [(ngModel)]="data.TotalPermanentSalary"
                                            maxlength="10" placeholder="Enter total permanent employee's salary"
                                            numbersOnly>
                                    </div>
                                    <div class="form-group col-lg-4 col-md-12 col-12 mb-0">
                                        <label><b>Total Ad-Hoc employee's salary</b></label>
                                        <input type="text" class="form-control" #TotalAdhocSalary="ngModel" ngModel
                                            name="TotalAdhocSalary" [(ngModel)]="data.TotalAdhocSalary" maxlength="10"
                                            placeholder="Enter total Ad-Hoc employee's salary" numbersOnly>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-xl-1 col-md-2 col-3">
                                        <label>&nbsp;</label>
                                        <button class="btn btn-success ml-3" type="button" style="margin: 5px;"
                                            (click)="addEmployeeDetail()">Add</button>
                                    </div>
                                    <div class="col-xl-1 col-md-2 col-3">
                                        <label>&nbsp;</label>
                                        <button class="btn btn-primary" type="button" style="margin: 5px;"
                                            (click)="clearEmployeeDetail()">Clear</button>
                                    </div>
                                </div>
                                <div class="form-group col-lg-12 col-md-12 col-12 mt-4"
                                    *ngIf="EmployeeDetail != undefined && EmployeeDetail.length > 0">
                                    <div class="table-responsive">
                                        <table class="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th>Employee category</th>
                                                    <th>No. of permanent employee</th>
                                                    <th>No. of Ad-Hoc employee</th>
                                                    <th>Total permanent employee's salary</th>
                                                    <th>Total Ad-Hoc employee's salary</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tr *ngFor="let t of EmployeeDetail;let i = index">
                                                <td>{{t.EmployeeType}}</td>
                                                <td>{{t.NoOfPermanentEmployee}}</td>
                                                <td>{{t.NoOfAdhocEmployee}}</td>
                                                <td>{{t.TotalPermanentSalary}}</td>
                                                <td>{{t.TotalAdhocSalary}}</td>
                                                <td style="white-space: nowrap;">
                                                    <button type="button" class="btn btn-success mt-0 mb-0 d-inline"
                                                        (click)="editEmployeeDetail(i)">Edit</button>
                                                    &nbsp; <button type="button" class="btn btn-danger mt-0 d-inline"
                                                        (click)="deleteEmployeeDetail(i)">Delete</button>
                                                </td>
                                            </tr>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div class="border border-dark bg-custom p-2 mt-2">
                                <h4>Principal Details</h4>
                                <hr style="margin: 0;">
                                <div class="row mt-2" style="margin: 2px;">
                                    <input type="hidden" value="-1" id="hid_principalDetailID">
                                    <div class="form-group col-lg-3 col-md-12 col-12">
                                        <label><b>Designation</b><span class="text-danger">*</span></label>
                                        <select class="form-control" #DesignationID="ngModel" ngModel
                                            name="DesignationID" [(ngModel)]="data.DesignationID" required>
                                            <option *ngFor="let des of designations" [value]="des.value"
                                                [selected]="data.DesignationID == des.value">
                                                {{ des.text }}
                                            </option>
                                        </select>
                                    </div>
                                    <div class="form-group col-lg-3 col-md-12 col-12 mb-0">
                                        <label><b>College's principal name</b><span class="text-danger">*</span></label>
                                        <input type="text" class="form-control" #PrincipalName="ngModel" ngModel
                                            name="PrincipalName" [(ngModel)]="data.PrincipalName" maxlength="200"
                                            placeholder="Enter college's principal name">
                                        <!-- <span *ngIf="RegistrationForm.submitted && PrincipalName.invalid">
                                                <p *ngIf="PrincipalName.errors.required" class="error_message"
                                                    style="color: red;">
                                                    School's Principal Name is required
                                                </p>
                                            </span> -->
                                    </div>
                                    <div class="form-group col-lg-3 col-md-12 col-12 mb-0">
                                        <label><b>Contact / mobile no.</b><span class="text-danger">*</span></label>
                                        <input type="text" class="form-control" #PrincipalMobileNo="ngModel" ngModel
                                            name="PrincipalMobileNo" [(ngModel)]="data.PrincipalMobileNo" minlength="10"
                                            maxlength="10" numbersOnly placeholder="Enter contact / mobile no.">
                                        <!-- <span *ngIf="RegistrationForm.submitted && PrincipalMobileNo.invalid">
                                                <p *ngIf="PrincipalMobileNo.errors.required" class="error_message"
                                                    style="color: red;">
                                                    Contact / Mobile No. is required
                                                </p>
                                                <p *ngIf="PrincipalMobileNo.errors.minlength" class="error_message"
                                                    style="color: red;">
                                                    Contact / Mobile No. must be of 10 digit
                                                </p>
                                                <p *ngIf="PrincipalMobileNo.errors.maxlength" class="error_message"
                                                    style="color: red;">
                                                    Contact / Mobile No. must be of maximun 10 digit
                                                </p>
                                            </span> -->
                                    </div>
                                    <div class="form-group col-lg-3 col-md-12 col-12 mb-0">
                                        <label><b>Principal's mail id</b><span class="text-danger">*</span></label>
                                        <input type="text" class="form-control" #PrincipalMailID="ngModel" ngModel
                                            name="PrincipalMailID" [(ngModel)]="data.PrincipalMailID" maxlength="50"
                                            placeholder="Enter principal's mail id"
                                            pattern="^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+$">
                                        <!-- <span *ngIf="RegistrationForm.submitted && PrincipalMailID.invalid">
                                                <p *ngIf="PrincipalMailID.errors.required" class="error_message"
                                                    style="color: red;">
                                                    Principal's Mail ID is required
                                                </p>
                                                <p *ngIf="PrincipalMailID.errors.pattern" class="error_message"
                                                    style="color: red;">
                                                    Principal's Mail ID is invalid
                                                </p>
                                            </span> -->
                                    </div>
                                </div>
                                <!-- <div class="row col-lg-3 col-md-3 col-6 mt-2">
                                        <button class="btn btn-primary" type="button" style="margin: 5px;"
                                            (click)="addPrincipal()">Add</button>
                                        <button class="btn btn-primary" type="button" style="margin: 5px;"
                                            (click)="clearPrincipal()">Clear</button>
                                    </div> -->


                                <div class="row  mt-2">
                                    <div class="col-xl-1 col-md-2 col-3">
                                        <button class="btn btn-success ml-3" type="button" style="margin: 5px;"
                                            (click)="addPrincipal()">Add</button>
                                    </div>
                                    <div class="col-xl-1 col-md-2 col-3">
                                        <button class="btn btn-primary" type="button" style="margin: 5px;"
                                            (click)="clearPrincipal()">Clear</button>
                                    </div>
                                </div>


                                <div class="form-group col-lg-12 col-md-12 col-12 mt-4">
                                    <div class="table-responsive">
                                        <table class="table table-bordered" *ngIf="PrincipalDetail.length > 0">
                                            <thead>
                                                <tr>
                                                    <th>Designation</th>
                                                    <th>Principal's name</th>
                                                    <th>Principal's mobile no.</th>
                                                    <th>Principal's mail id</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tr *ngFor="let t of PrincipalDetail;let j = index">
                                                <td>{{t.PrinDesignation}}</td>
                                                <td>{{t.PrincipalName}}</td>
                                                <td>{{t.PrincipalMobileNo}}</td>
                                                <td>{{t.PrincipalMailID}}</td>
                                                <td style="white-space: nowrap;">
                                                    <button type="button" class="btn btn-success mt-0 mb-0 d-inline"
                                                        (click)="editPrincipal(j)">Edit</button>
                                                    &nbsp; <button type="button" class="btn btn-danger mt-0 d-inline"
                                                        (click)="deletePrincipal(j)">Delete</button>
                                                </td>
                                            </tr>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div class="border border-dark  bg-custom  p-2 mt-2">
                                <h4>Employee Qualification Details</h4>
                                <hr style="margin: 0;">
                                <div class="row mt-2 " style="margin: 2px;">
                                    <input type="hidden" value="-1" id="hid_EmployeeQualificationDetailID">
                                    <div class="form-group col-lg-4 col-md-12 col-12">
                                        <label><b>Qualification type</b><span class="text-danger">*</span></label>
                                        <select class="form-control" #EmployeeQualificationTypeID="ngModel" ngModel
                                            name="EmployeeQualificationTypeID" [(ngModel)]="data.QualificationID"
                                            required>
                                            <option *ngFor="let inf of qualifications" [value]="inf.value"
                                                [selected]="data.QualificationID == inf.value">
                                                {{ inf.text }}
                                            </option>
                                        </select>
                                    </div>
                                    <div class="form-group col-lg-4 col-md-12 col-12 mb-0">
                                        <label><b>No. of employees</b><span class="text-danger">*</span></label>
                                        <input type="text" class="form-control" #NoOfEmployee="ngModel" ngModel
                                            name="NoOfEmployee" [(ngModel)]="data.NoofEmployee" maxlength="10"
                                            placeholder="Enter no. of employee" numbersOnly>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-xl-1 col-md-2 col-3">
                                        <label>&nbsp;</label>
                                        <button class="btn btn-success ml-3" type="button" style="margin: 5px;"
                                            (click)="addEmployeeQualification()">Add</button>
                                    </div>
                                    <div class="col-xl-1 col-md-2 col-3">
                                        <label>&nbsp;</label>
                                        <button class="btn btn-primary" type="button" style="margin: 5px;"
                                            (click)="clearEmployeeQualification()">Clear</button>
                                    </div>
                                </div>
                                <div class="form-group col-lg-12 col-md-12 col-12 mt-4"
                                    *ngIf="EmployeeQualificationDetail != undefined && EmployeeQualificationDetail.length > 0">
                                    <div class="table-responsive">
                                        <table class="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th>Qualification type</th>
                                                    <th>No. of employees</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tr *ngFor="let t of EmployeeQualificationDetail;let i = index">
                                                <td>{{t.Qualification}}</td>
                                                <td>{{t.NoofEmployee}}</td>
                                                <td style="white-space: nowrap;">
                                                    <button type="button" class="btn btn-success mt-0 mb-0 d-inline"
                                                        (click)="editEmployeeQualification(i)">Edit</button>
                                                    &nbsp; <button type="button" class="btn btn-danger mt-0 d-inline"
                                                        (click)="deleteEmployeeQualification(i)">Delete</button>
                                                </td>
                                            </tr>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div class="row mt-2">
                                <div class="form-group col-lg-4 col-md-12 col-12">
                                    <label><b>Name of authorized person who remained present in submitted
                                            affidevit</b>
                                        <span class="text-danger">*</span></label>
                                    <input type="text" class="form-control" #AuthorizedPerson="ngModel" ngModel
                                        name="AuthorizedPerson" [(ngModel)]="data.AuthorizedPerson" maxlength="50"
                                        placeholder="Enter name of authorized person" required>
                                    <span *ngIf="RegistrationForm.submitted && AuthorizedPerson.invalid">
                                        <p *ngIf="AuthorizedPerson.errors.required" class="error_message"
                                            style="color: red;">
                                            Name of authorized person is required
                                        </p>
                                    </span>
                                </div>
                                <div class="form-group col-lg-4 col-md-12 col-12">
                                    <label><b>Designation</b><span class="text-danger">*</span></label>
                                    <input type="text" class="form-control" #Designation="ngModel" ngModel
                                        name="Designation" [(ngModel)]="data.Designation" maxlength="50"
                                        placeholder="Enter designation" required>
                                    <span *ngIf="RegistrationForm.submitted && Designation.invalid">
                                        <p *ngIf="Designation.errors.required" class="error_message"
                                            style="color: red;">
                                            Designation is required
                                        </p>
                                    </span>
                                </div>
                                <div class="form-group col-lg-4 col-md-12 col-12">
                                    <label><b>Contact / Mobile no.</b><span class="text-danger">*</span></label>
                                    <input type="text" class="form-control" #MobileNo="ngModel" ngModel name="MobileNo"
                                        [(ngModel)]="data.MobileNo" numbersOnly placeholder="Enter contact / mobile no."
                                        minlength="10" maxlength="10" required>
                                    <span *ngIf="RegistrationForm.submitted && MobileNo.invalid">
                                        <p *ngIf="MobileNo.errors.required" class="error_message" style="color: red;">
                                            Contact / mobile no. is required
                                        </p>
                                        <p *ngIf="MobileNo.errors.minlength" class="error_message" style="color: red;">
                                            Contact / mobile no. must be of 10 digit
                                        </p>
                                        <p *ngIf="MobileNo.errors.maxlength" class="error_message" style="color: red;">
                                            Contact / mobile no. must be of maximun 10 digit
                                        </p>
                                    </span>
                                </div>
                            </div>
                            <div class="row mt-2">
                                <div class="form-group col-lg-4 col-md-12 col-12">
                                    <label><b>Whatsapp mobile no.</b><span class="text-danger">*</span></label>
                                    <input type="text" class="form-control" #WhatsAppNo="ngModel" ngModel
                                        name="WhatsAppNo" [(ngModel)]="data.WhatsAppNo" numbersOnly
                                        placeholder="Enter whatsapp contact / mobile no." minlength="10" maxlength="10"
                                        required>
                                    <span *ngIf="RegistrationForm.submitted && WhatsAppNo.invalid">
                                        <p *ngIf="WhatsAppNo.errors.required" class="error_message" style="color: red;">
                                            Whatsapp mobile no. is required
                                        </p>
                                        <p *ngIf="WhatsAppNo.errors.minlength" class="error_message"
                                            style="color: red;">
                                            Whatsapp mobile no. must be of 10 digit
                                        </p>
                                        <p *ngIf="WhatsAppNo.errors.maxlength" class="error_message"
                                            style="color: red;">
                                            Whatsapp mobile no. must be of maximun 10 digit
                                        </p>
                                    </span>
                                </div>
                            </div>
                            <div class="row mt-2 p-2">
                                <div class="form-group col-lg-12 col-md-12 col-12 m-1 p-2"
                                    style="border: 1px solid black;" *ngFor="let s of standardList; let i=index">
                                    <div class="col-lg-3 col-md-12 col-12 pl-0">
                                        <label><b>{{s.text}}</b>
                                        </label>
                                        <input type="text" class="form-control" ngModel name="std{{i}}_{{i}}" id="std{{i}}_{{i}}"
                                            numbersOnly maxlength="2" placeholder="Enter no. of division"
                                            (keyup)="fillDiv(s.value,i,s.year)">
                                    </div>
                                    <div id="divlist{{s.value}}_{{i}}_{{s.year}}">
                                        
                                    </div>
                                </div>
                                <!-- <div class="form-group col-lg-2 col-md-12 col-12">
                                        <label>Nursery
                                        </label>
                                        <input type="text" class="form-control" #Nursery="ngModel" ngModel
                                            name="Nursery" [(ngModel)]="data.Nursery" numbersOnly maxlength="11"
                                            placeholder="Enter Number Of Student">
                                    </div>
                                    <div class="form-group col-lg-2 col-md-12 col-12">
                                        <label>jr. Kg.
                                        </label>
                                        <input type="text" class="form-control" #jrKg="ngModel" ngModel name="jrKg"
                                            [(ngModel)]="data.jrKg" numbersOnly maxlength="11"
                                            placeholder="Enter Number Of Student">
                                    </div> -->
                            </div>
                            <!-- // Infrastructure and Owner entry remove from page.
                            <div class="border border-dark bg-custom p-2">
                                <h5><b>Land owner Detail</b></h5>
                                <div class="row mt-2" style="margin: 2px;">
                                    <input type="hidden" value="-1" id="hid_ownerDetailID">
                                    <div class="form-group col-lg-4 col-md-12 col-12 mb-0">
                                        <label><b>Land owner name</b><span class="text-danger">*</span></label>
                                        <input type="text" class="form-control" #OwnerName="ngModel" ngModel
                                            name="OwnerName" [(ngModel)]="data.OwnerName" maxlength="200"
                                            placeholder="Enter land owner name">
                                    </div>
                                    <div class="form-group col-lg-4 col-md-12 col-12 mb-0">
                                        <label><b>Owner's contact / mobile no.</b><span
                                                class="text-danger">*</span></label>
                                        <input type="text" class="form-control" #OwnerMobileNo="ngModel" ngModel
                                            name="OwnerMobileNo" [(ngModel)]="data.OwnerMobileNo" minlength="10"
                                            maxlength="10" numbersOnly placeholder="Enter owner contact / mobile no.">
                                    </div>
                                    <div class="form-group col-lg-4 col-md-12 col-12 mb-0">
                                        <label><b>Owner's mail id</b><span class="text-danger">*</span></label>
                                        <input type="text" class="form-control" #OwnerMailID="ngModel" ngModel
                                            name="OwnerMailID" [(ngModel)]="data.OwnerMailID" maxlength="50"
                                            placeholder="Enter owner's mail id"
                                            pattern="^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+$">
                                    </div>
                                </div>
                                <div class="row  mt-2">
                                    <div class="col-xl-1 col-md-2 col-3">
                                        <button class="btn btn-success ml-3" type="button" style="margin: 5px;"
                                            (click)="addOwner()">Add</button>
                                    </div>
                                    <div class="col-xl-1 col-md-2 col-3">
                                        <button class="btn btn-primary" type="button" style="margin: 5px;"
                                            (click)="clearOwner()">Clear</button>
                                    </div>
                                </div>
                                <div class="form-group col-lg-12 col-md-12 col-12 mt-4">
                                    <div class="table-responsive">
                                        <table class="table table-bordered" *ngIf="OwnerDetail.length > 0">
                                            <thead>
                                                <tr>
                                                    <th>Owner's name</th>
                                                    <th>Owner's mobile no</th>
                                                    <th>Owner's mail id</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tr *ngFor="let o of OwnerDetail;let j = index">
                                                <td>{{o.OwnerName}}</td>
                                                <td>{{o.OwnerMobileNo}}</td>
                                                <td>{{o.OwnerMailID}}</td>
                                                <td style="white-space: nowrap;">
                                                    <button type="button" class="btn btn-success mt-0 mb-0 d-inline"
                                                        (click)="editOwner(j)">Edit</button>
                                                    &nbsp; <button type="button" class="btn btn-danger mt-0 d-inline"
                                                        (click)="deleteOwner(j)">Delete</button>
                                                </td>
                                            </tr>
                                        </table>
                                    </div>
                                </div>
                            </div> -->
                            <!-- <div class="row mt-2">
                                <div class="form-group col-lg-4 col-md-12 col-12">
                                    <label><b>Land area in square feet</b>
                                        <span class="text-danger">*</span></label>
                                    <input type="text" class="form-control" #LandArea="ngModel" ngModel name="LandArea"
                                        [(ngModel)]="data.LandArea" maxlength="50"
                                        (keypress)="onlyDouble($event,data.LandArea)"
                                        placeholder="Enter land area in square feet" required>
                                    <span *ngIf="RegistrationForm.submitted && LandArea.invalid">
                                        <p *ngIf="LandArea.errors.required" class="error_message" style="color: red;">
                                            Land area in square feet is required
                                        </p>
                                    </span>
                                </div>
                                <div class="form-group col-lg-4 col-md-12 col-12">
                                    <label><b>Land construction group and total both</b>
                                        <span class="text-danger">*</span></label>
                                    <input type="text" class="form-control" #LandConstruction="ngModel" ngModel
                                        name="LandConstruction" [(ngModel)]="data.LandConstruction" maxlength="50"
                                        (keypress)="onlyDouble($event,data.LandConstruction)"
                                        placeholder="Enter land area in square feet" required>
                                    <span *ngIf="RegistrationForm.submitted && LandConstruction.invalid">
                                        <p *ngIf="LandConstruction.errors.required" class="error_message"
                                            style="color: red;">
                                            Land construction group and total both is required
                                        </p>
                                    </span>
                                </div>
                            </div> -->
                            <!-- <div class="border border-dark bg-custom p-2">
                                <h5><b>Pending Salary Increment</b></h5>
                                <hr style="margin: 0;">
                                <div class="row mt-2" style="margin: 2px;">
                                    <div class="form-group col-lg-4 col-md-12 col-12 mb-0">
                                        <label><b>Amount</b><span class="text-danger">*</span></label>
                                        <input type="text" class="form-control" #PendingSalaryIncrementAmount="ngModel"
                                            ngModel name="PendingSalaryIncrementAmount"
                                            [(ngModel)]="data.PendingSalaryIncrementAmount" maxlength="20"
                                            (keypress)="onlyDouble($event,data.PendingSalaryIncrementAmount)"
                                            placeholder="Enter amount" required>
                                        <span
                                            *ngIf="RegistrationForm.submitted && PendingSalaryIncrementAmount.invalid">
                                            <p *ngIf="PendingSalaryIncrementAmount.errors.required"
                                                class="error_message" style="color: red;">
                                                Amount is required
                                            </p>
                                        </span>
                                    </div>
                                    <div class="form-group col-lg-4 col-md-12 col-12 mb-0">
                                        <label><b>Description</b><span class="text-danger">*</span></label>
                                        <textarea class="form-control" #PendingSalaryIncrementDescription="ngModel"
                                            ngModel name="PendingSalaryIncrementDescription" rows="3" maxlength="200"
                                            style="height: 60px"
                                            [(ngModel)]="data.PendingSalaryIncrementDescription"></textarea>
                                    </div>
                                </div>
                            </div>
                            <div class="border border-dark bg-custom p-2 mt-2">
                                <h5><b>Depreciation</b></h5>
                                <hr style="margin: 0;">
                                <div class="row mt-2" style="margin: 2px;">
                                    <div class="form-group col-lg-4 col-md-12 col-12 mb-0">
                                        <label><b>Amount</b><span class="text-danger">*</span></label>
                                        <input type="text" class="form-control" #DepreciationAmount="ngModel" ngModel
                                            name="DepreciationAmount" [(ngModel)]="data.DepreciationAmount"
                                            maxlength="20" (keypress)="onlyDouble($event,data.DepreciationAmount)"
                                            placeholder="Enter amount" required>
                                        <span *ngIf="RegistrationForm.submitted && DepreciationAmount.invalid">
                                            <p *ngIf="DepreciationAmount.errors.required" class="error_message"
                                                style="color: red;">
                                                Amount is required
                                            </p>
                                            <p *ngIf="data.DepreciationAmount <= 0" class="error_message"
                                                style="color: red;">
                                                Amount must be greater then zero
                                            </p>
                                        </span>
                                    </div>
                                    <div class="form-group col-lg-4 col-md-12 col-12 mb-0">
                                        <label><b>Description</b><span class="text-danger">*</span></label>
                                        <textarea class="form-control" #DepreciationDescription="ngModel" ngModel
                                            name="DepreciationDescription" rows="3" maxlength="200" style="height: 60px"
                                            [(ngModel)]="data.DepreciationDescription"></textarea>
                                    </div>
                                </div>
                            </div> -->
                            <!-- <div class="border border-dark bg-custom p-2 mt-2">
                                <div class="row mt-2" style="margin: 2px;">
                                    <div class="form-group col-lg-4 col-md-12 col-12 mb-0">
                                        <label><b>Total available classrooms</b><span
                                                class="text-danger">*</span></label>
                                        <input type="text" class="form-control" #NoOfClassroom="ngModel" ngModel
                                            name="NoOfClassroom" [(ngModel)]="data.NoOfClassroom" maxlength="20"
                                            (keyup)="fillClassRooms()" numbersOnly
                                            placeholder="Enter total available classrooms" required>
                                        <span *ngIf="RegistrationForm.submitted && NoOfClassroom.invalid">
                                            <p *ngIf="NoOfClassroom.errors.required" class="error_message"
                                                style="color: red;">
                                                Total available classrooms is required
                                            </p>
                                        </span>
                                    </div>
                                </div>
                                <div id="divClassRoom" style="width: 100%;">
                                    
                                </div>
                            </div> -->
                            <!-- <div class="row mt-2">
                                <div class="form-group col-lg-4 col-md-12 col-12">
                                    <label><b>Land area in square feet</b>
                                        <span class="text-danger">*</span></label>
                                    <input type="text" class="form-control" #LandArea="ngModel" ngModel name="LandArea"
                                        [(ngModel)]="data.LandArea" maxlength="50"
                                        (keypress)="onlyDouble($event,data.LandArea)"
                                        placeholder="Enter land area in square feet" required>
                                    <span *ngIf="RegistrationForm.submitted && LandArea.invalid">
                                        <p *ngIf="LandArea.errors.required" class="error_message" style="color: red;">
                                            Land area in square feet is required
                                        </p>
                                    </span>
                                </div>
                                <div class="form-group col-lg-4 col-md-12 col-12">
                                    <label><b>Land construction group and total both</b>
                                        <span class="text-danger">*</span></label>
                                    <input type="text" class="form-control" #LandConstruction="ngModel" ngModel
                                        name="LandConstruction" [(ngModel)]="data.LandConstruction" maxlength="50"
                                        (keypress)="onlyDouble($event,data.LandConstruction)"
                                        placeholder="Enter land area in square feet" required>
                                    <span *ngIf="RegistrationForm.submitted && LandConstruction.invalid">
                                        <p *ngIf="LandConstruction.errors.required" class="error_message"
                                            style="color: red;">
                                            Land construction group and total both is required
                                        </p>
                                    </span>
                                </div>
                            </div> -->
                            <div class="row mt-2" *ngIf="visibleRemarkDiv">
                                <div class="form-group col-lg-4 col-md-12 col-12">
                                    <label><b>Admin Remarks</b><span class="text-danger">*</span></label>
                                    <textarea class="form-control" #Remarks="ngModel" ngModel name="Remarks" rows="3"
                                        maxlength="300" style="height: 60pxFaculty" [(ngModel)]="data.Remarks"
                                        disabled></textarea>
                                </div>
                            </div>
                            <div class="row mt-2">
                                <button class="btn btn-success" type="submit" id="btnsubmit"
                                    style="margin: 5px;">{{btnsubmittext}}</button>
                                <button class="btn btn-primary" type="Reset" *ngIf="data.ID==0"
                                    style="margin: 5px;">Clear</button>
                                <button class="btn btn-danger" type="button" style="margin: 5px;"
                                    (click)="redirectToProfile()">Cancel</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal inmodal" data-backdrop="static" data-keyboard="false" id="registrationReqModal" tabindex="-1"
            *ngIf="openmodal" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-xl">
                <div class="modal-content animated flipInY">
                    <div class="modal-header">
                        <h4 class="modal-title">Registration Pending Req.</h4>
                        <button type="button" class="close" data-dismiss="modal" (click)="closeForm()"><span
                                aria-hidden="true">&times;</span>
                            <span class="sr-only">Close</span></button>
                    </div>
                    <div class="modal-body modal_box">
                        <div class="row mt-2">
                            <div class="form-group col-lg-12 col-md-12 col-12 mt-2"
                                *ngIf="TrusteeDetailReq != undefined && TrusteeDetailReq != null && TrusteeDetailReq.length > 0">
                                <div class="border border-dark bg-custom p-2">
                                    <h4>TRUSTEE'S DETAILS</h4>
                                    <div class="table-responsive">
                                        <table class="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th>Trustee's name</th>
                                                    <th>Trustee's address</th>
                                                    <th>Trustee's contact / mobile no.</th>
                                                    <th>Trustee's mail id</th>
                                                </tr>
                                            </thead>
                                            <tr *ngFor="let t of TrusteeDetailReq;">
                                                <td>{{t.TrusteeName}}</td>
                                                <td>{{t.TrusteeAddress}}</td>
                                                <td>{{t.TrusteeMobileNo}}</td>
                                                <td>{{t.TrusteeMailID}}</td>
                                            </tr>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group col-lg-12 col-md-12 col-12 mt-2"
                                *ngIf="PrincipalDetailReq != undefined && PrincipalDetailReq != null && PrincipalDetailReq.length > 0">
                                <div class="border border-dark bg-custom p-2">
                                    <h4>Principal/Supervisor/Director's details</h4>
                                    <div class="table-responsive">
                                        <table class="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th>Designation</th>
                                                    <th>Name</th>
                                                    <th>Mobile no.</th>
                                                    <th>Mail id</th>
                                                </tr>
                                            </thead>
                                            <tr *ngFor="let t of PrincipalDetailReq;let j = index">
                                                <td>{{t.PrinDesignation}}</td>
                                                <td>{{t.PrincipalName}}</td>
                                                <td>{{t.PrincipalMobileNo}}</td>
                                                <td>{{t.PrincipalMailID}}</td>
                                            </tr>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-6 col-md-6 col-sm-6">
                                <div class="table-responsive">
                                    <table class="table table-borderless mb-0">
                                        <tbody>
                                            <tr>
                                                <td width="50%">
                                                    <p><strong>Name of authorized person:</strong></p>
                                                </td>
                                                <td width="50%">
                                                    <p>{{d["AuthorizedPerson"]}}</p>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td width="50%">
                                                    <p><strong>Designation:</strong></p>
                                                </td>
                                                <td width="50%">
                                                    <p>{{d["Designation"]}}</p>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div class="col-lg-6 col-md-6 col-sm-6">
                                <div class="table-responsive">
                                    <table class="table table-borderless mb-0">
                                        <tbody>
                                            <tr>
                                                <td width="50%">
                                                    <p><strong>Authorized person contact/mobile no.:</strong></p>
                                                </td>
                                                <td width="50%">
                                                    <p>{{d["MobileNo"]}}</p>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td width="50%">
                                                    <p><strong>Authorized person whatsapp no.:</strong></p>
                                                </td>
                                                <td width="50%">
                                                    <p>{{d["WhatsAppNo"]}}</p>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                        </div>
                        <div class="form-group col-lg-12 col-md-12 col-12 mt-2"
                            *ngIf="StandardDetailReq != undefined && StandardDetailReq != null && StandardDetailReq.length > 0">
                            <div class="border border-dark bg-custom p-2">
                                <h4>Course details</h4>
                                <div class="table-responsive">
                                    <table class="table table-bordered">
                                        <thead>
                                            <tr>
                                                <th>Course</th>
                                                <th>Division details (division name - student counts)</th>
                                            </tr>
                                        </thead>
                                        <tr *ngFor="let t of StandardDetailReq;let j = index">
                                            <td>{{t.DivisionName}}</td>
                                            <td>{{t.StudentCount}}</td>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <div class="row p-3 per_info">
                            <div class="form-group col-lg-12 col-md-12 col-12"
                                *ngIf="OwnerDetailReq != undefined && OwnerDetailReq != null && OwnerDetailReq.length > 0">
                                <div class="border border-dark bg-custom p-2">
                                    <h4>Land owner's details</h4>
                                    <div class="table-responsive">
                                        <div class="table-responsive">
                                            <table class="table table-bordered">
                                                <thead>
                                                    <tr>
                                                        <th>Owner's name</th>
                                                        <th>Owner's mobile no</th>
                                                        <th>Owner's mail id</th>
                                                    </tr>
                                                </thead>
                                                <tr *ngFor="let o of OwnerDetailReq;let j = index">
                                                    <td>{{o.OwnerName}}</td>
                                                    <td>{{o.OwnerMobileNo}}</td>
                                                    <td>{{o.OwnerMailID}}</td>
                                                </tr>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- <div class="row p-3 per_info">
                            <div class="col-lg-6 col-md-6 col-sm-6">
                                <div class="table-responsive">
                                    <table class="table table-borderless mb-0">
                                        <tbody>
                                            <tr>
                                                <td width="50%">
                                                    <p><strong>Land area in square feet:</strong></p>
                                                </td>
                                                <td width="50%">
                                                    <p>{{d["LandArea"]}}</p>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td width="50%">
                                                    <p><strong>Land construction group and total both:</strong></p>
                                                </td>
                                                <td width="50%">
                                                    <p>{{d["LandConstruction"]}}</p>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td width="50%">
                                                    <p><strong>Pending salary increment amount:</strong></p>
                                                </td>
                                                <td width="50%">
                                                    <p>{{d["PendingSalaryIncrementAmount"]}}</p>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div class="col-lg-6 col-md-6 col-sm-6">
                                <div class="table-responsive">
                                    <table class="table table-borderless mb-0">
                                        <tbody>
                                            <tr>
                                                <td width="50%">
                                                    <p><strong>Pending salary increment description:</strong></p>
                                                </td>
                                                <td width="50%">
                                                    <p>{{d["PendingSalaryIncrementDescription"]}}</p>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td width="50%">
                                                    <p><strong>Depreciation amount:</strong></p>
                                                </td>
                                                <td width="50%">
                                                    <p>{{d["DepreciationAmount"]}}</p>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td width="50%">
                                                    <p><strong>Depreciation description:</strong></p>
                                                </td>
                                                <td width="50%">
                                                    <p>{{d["DepreciationDescription"]}}</p>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="footer-login custom-footer">
        <p class="mb-0">Copyright © Netsol IT Solution Pvt. Ltd. 2020 All Rights Reserved</p>
        <img src="assets/images/powered-by.png" alt="netsol-powerd by" class="img-fluid">
    </div>
    <ngx-spinner bdcolor="rgba(51, 51, 51, 0.8)" size="default" type="ball-spin-clockwise">
        <p style="color: white;">Please Wait.</p>
    </ngx-spinner>
</div>